<template>
    <div class="login-container">
      <nav-bar :showBack="false"/>
      <van-form @submit="onSubmit">
        <div class="page-title"> {{$t('注册云米账号')}} </div>
        <div class="page-tip"> {{ $t('验证码已发送至') + this.user.email }} </div>
        <van-field v-show="isCaptcha" v-model="user.captcha" class="custom-field" :placeholder="$t('请输入图片验证码')">
        <template #button>
          <img :src="captchaSrc" class="captchaImg" @click="getCrateCaptchaSub">
        </template>
      </van-field>
      <van-field v-model="user.code" class="custom-field" :placeholder="$t('请输入邮箱验证码')" type="number">
        <template #button>
          <van-count-down v-show="isCountDownShow" ref="countDown" millisecond :time="1000*60" :auto-start="false" format="ss" @finish="finish">
            <template #default="timeData">
                <span class="countDownBlock">{{ $t('重新发送')+ '(' +timeData.seconds + 's)'}}</span>
            </template>
          </van-count-down>
          <span v-show="!isCountDownShow" class="send-sms-btn" @click="onSendMailCode"> {{$t('获取验证码')}} </span>
        </template>
      </van-field>

        <van-button class="login-btn" :disabled="!user.code || (isCaptcha&&!user.captcha)" block type="info" native-type="submit">
          {{ $t('提交') }}
        </van-button>

        <div class="page-tip-bottom"> {{$t('注册成功后将自动完成授权登录')}} </div>

      </van-form>

      <tip-popup-view v-model="tipShow" :tip-content="tipContent" :button-content="tipButton"/>
      <van-popup v-model="show" round position="bottom" :style="{ height: '70%' }"><iframe class="iframeBody" :src="iframeLink"></iframe></van-popup>
    </div>
  </template>
<script>

import { Encrypt } from '@/utils/crypto.js'
import md5 from 'js-md5'

import { Icon, Form, Field, Button, CheckboxGroup, Checkbox, CountDown, Toast, Popup, Dialog } from 'vant'
import { sendEmailRegisterCode } from '@/api/common/index'
import NavBar from '@/components/NavBar'
import TipPopupView from '@/components/TipPopupView'
import PageBase from '@/mixin/page-base'

export default {
  mixins: [PageBase],
  components: {
    NavBar,
    TipPopupView,
    [Icon.name]: Icon,
    [Form.name]: Form,
    [Field.name]: Field,
    [Button.name]: Button,
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
    [CountDown.name]: CountDown,
    [Toast.name]: Toast,
    [Popup.name]: Popup,
    [Dialog.name]: Dialog
  },
  props: {},
  data () {
    return {
      user: {
        email: '',
        password: '',
        captcha: '',
        code: ''
      },
      show: false,
      iframeLink: '',
      openEye: false,
      isCountDownShow: false,
      isCaptcha: false,
      captchaSrc: ''
    }
  },
  computed: {},
  watch: {},
  created () {
  },
  mounted () {
    this.initParamter()

    this.user.email = this.$store.getters.registerParam.email
    this.user.password = this.$store.getters.registerParam.password

    this.onSendMailCode()
  },
  methods: {

    onSubmit () {
      const user = this.user
      let data = {
        authorization: this.authorization()
      }

      data.emailAuthentication = {
        email: Encrypt(user.email),
        password: md5(user.password),
        rePassword: md5(user.password),
        verifyCode: this.user.code
      }
      data.authentication = {
        loginType: 'email',
        userType: '2'
      }

      this.commonAuth(data)
    },

    goLink (link) {
      this.iframeLink = link
      this.show = true
    },

    onSendMailCode () {
      if (this.isCaptcha && !this.user.captcha) {
        Toast(this.$t('请输入图片验证码'))
        return
      }
      let data = {
        email: Encrypt(this.user.email)
      }
      if (this.isCaptcha) {
        data.captcha = this.user.captcha
      }

      this.showLoading(this.$t('获取验证码...'))
      sendEmailRegisterCode(data).then(res => {
        this.dismissLoading()
        if (res.code === 100) {
          if (!res.mobBaseRes.result) {
            this.getCrateCaptchaSub()
          } else {
            Toast(this.$t('验证码已发送'))
            this.isCountDownShow = true
            this.$refs.countDown.reset()
            this.$refs.countDown.start()
          }
        } else {
          this.showTipPopup(res.desc, this.$t('确定'))
        }
      }).catch((error) => {
        this.dismissLoading()
        this.showTipPopup(error, this.$t('确定'))
      })
    },

    getCrateCaptchaSub () {
      this.getCrateCaptcha({ identifier: Encrypt(this.user.email) })
    },

    finish () {
      this.isCountDownShow = false
    }

  }
}
</script>
  <style scoped lang="less">
  .login-container {
    background: #ffffff;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    position: relative;
    padding: 0px 24px;
    .viomi-logo {
      width: 59px;
      height: 52px;
      margin-top: 28px;
      align-self: center;
    }
    .page-title {
      margin-bottom: 28px;
      font-size: 24px;
      font-weight: 500;
      color: #2C2C2C;
      align-self: center;
      text-align: center;
    }
    .page-tip {
        font-size: 12px;
        color: #999;
        margin-top:18px;
    }
    .page-tip-bottom {
        font-size: 12px;
        color: #999;
        margin-top:18px;
        text-align: center;
    }
    .password-tip {
        font-size: 12px;
        color: #999999;
        margin-top: 12px;
    }
    .custom-field {
      background-color: #F5F7FA;
      margin-top: 8px;
      border-radius: 8px;
      font-size: 14px;
      .captchaImg {
        width: 104px;
        height: 36px;
        }
    }
    .custom-field /deep/ .van-field__control {
      border-bottom: none;
      height: 40px;
    }
    .custom-field /deep/ .van-field__button {
      display: flex;
      align-items: center;
    }
    .forget-pwd {
      font-size: 12px;
      font-weight: 400;
      color: gray;
      align-self: flex-end;
      text-align: right;
      margin-top: 16px;
    }

    .input-desc {
      font-size: 10px;
      color: #999999;
      line-height: 20px;
      position: relative;
      opacity: 0;
    }
    .inputDescAct {
      opacity: 1;
      animation: myfirst 0.05s;
      -webkit-animation: myfirst 1s; /* Safari and Chrome */
    }
    @keyframes myfirst {
      0% {
        opacity: 0;
        left: 0px;
        top: 5px;
      }
      100% {
        opacity: 1;
        left: 0px;
        top: 0px;
      }
    }

    @-webkit-keyframes myfirst /* Safari and Chrome */ {
      0% {
        opacity: 0;
        left: 0px;
        top: 5px;
      }
      100% {
        opacity: 1;
        left: 0px;
        top: 0px;
      }
    }
    .send-sms-btn {
      height: 16px;
      line-height: 16px;
      font-size: 13px;
      color: #28beca;
    }
    .login-btn {
      margin-top: 16px;
      background: linear-gradient(90deg, #5fd1db 0%, #28beca 100%);
      border: none;
      border-radius: 8px;
      height: 48px;
      font-size: 14px;
      width:327px;
    }
    .countDownBlock {
      color: #ace6ebff;
      font-size: 13px;
    }
    .iframeBody {
      width: 100%;
      height: 100%;
    }
  }
  </style>
